"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultilingualService = void 0;
var getLocaleNamespace_1 = require("../getLocaleNamespace");
var MultilingualService = /** @class */ (function () {
    function MultilingualService(publicData, widgetSettings, multiLangFields, defaultLocale) {
        if (publicData === void 0) { publicData = {}; }
        this.publicData = publicData;
        this.widgetSettings = widgetSettings;
        this.multiLangFields = multiLangFields;
        this.defaultLocale = defaultLocale;
        if (multiLangFields) {
            this.isPrimaryLanguage = this.multiLangFields.isPrimaryLanguage;
            this.lang = this.multiLangFields.lang;
        }
        else {
            this.isPrimaryLanguage = true;
            this.lang = this.defaultLocale;
        }
    }
    MultilingualService.prototype.get = function (key) {
        if (this.isPrimaryLanguage) {
            return this.publicData[key];
        }
        else {
            var widgetSettingsTextsMap = this.widgetSettings[getLocaleNamespace_1.getLocaleNamespace(this.lang)];
            return widgetSettingsTextsMap && widgetSettingsTextsMap[key];
        }
    };
    MultilingualService.prototype.getAll = function () {
        return this.isPrimaryLanguage ? this.publicData : this.widgetSettings[getLocaleNamespace_1.getLocaleNamespace(this.lang)];
    };
    MultilingualService.prototype.setWidgetSettings = function (data) {
        this.widgetSettings = data;
    };
    MultilingualService.prototype.setPublicData = function (data) {
        this.publicData = data;
    };
    return MultilingualService;
}());
exports.MultilingualService = MultilingualService;
//# sourceMappingURL=multilingualService.js.map